import Vue from 'vue'
import App from './App.vue'
import './global/loaders/global-components'
import router from './global/router.js'
import store from './global/store.js'
import vuetify from './global/plugins/vuetify'
import translator from './global/plugins/translator'
import { init as bugsnagInit } from './global/plugins/error-reporting'
import VueFlags from '@growthbunker/vueflags'

Vue.config.productionTip = false
////////////////
//////////////////////////
//////////

async function bootstrap () {
  try {
    await bugsnagInit(Vue)
  }
  finally {
    const loader = document.getElementById('preloader')
    if (loader) {
      loader.remove()
    }
  }

  Vue.use(translator, store)
  Vue.use(VueFlags, {
    iconPath: '/img/icons/flags'
  })

  new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App)
  }).$mount('#app')
}

bootstrap().then()
